// extracted by mini-css-extract-plugin
module.exports = {"main_title":"Reviews_main_title__2t8ki","person":"Reviews_person__1G44H","photo":"Reviews_photo__1BxYB","text":"Reviews_text__13TsG","name":"Reviews_name__148Pz"};